import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'telefone',
})
export class TelefonePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return null

    const clearPhone = value.replace(/\D/g, '')
    if (clearPhone.length === 11) return value.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3')
    if (clearPhone.length === 10) return value.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3')
    if (clearPhone.length === 9) return value.replace(/^(\d{5})(\d{4})$/, '$1-$2')
    if (clearPhone.length === 8) return value.replace(/^(\d{4})(\d{4})$/, '$1-$2')
    if (clearPhone.length === 7) return value.replace(/^(\d{3})(\d{4})$/, '$1-$2')

    return value
  }
}
